import { useState } from "react";
import { Carousel, Container } from "react-bootstrap";

import { homeBg4, homeBg5 } from "../../../constants/image_path";

const HomeCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => setIndex(selectedIndex);

  return (
    <Container className="mt-2 mb-2">
      <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img
            className="img-thumbnail home__bg"
            src={homeBg4}
            alt="First slide"
            style={{ height: "200px", objectFit: "cover" }}
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="img-thumbnail home__bg"
            src={homeBg5}
            alt="Second slide"
            style={{ height: "200px", objectFit: "cover" }}
          />
        </Carousel.Item>
      </Carousel>
    </Container>
  );
};

export default HomeCarousel;
